import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-135">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-136">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="bg-offwhite text-charcoal rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-137">
            <div className="flex items-center justify-between p-6 border-b border-sage" data-id="element-138">
              <h3 className="font-serif text-2xl font-bold text-forest" data-id="element-139">
                {title}
              </h3>
              <button onClick={onClose} className="text-charcoal/50 hover:text-charcoal transition-colors p-1 rounded-full hover:bg-sage/50" data-id="element-140">
                <X size={24} data-id="element-141" />
              </button>
            </div>
            <div className="p-6 text-sm leading-relaxed text-charcoal/80 space-y-4" data-id="element-142">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-forest-dark text-sage-dark py-12 px-4 text-center text-sm" data-id="element-143">
        <div className="max-w-4xl mx-auto" data-id="element-144">
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-145">
            <button onClick={() => setShowPrivacy(true)} className="text-sage-dark/80 hover:text-amber transition-colors underline underline-offset-4" data-id="element-146">
              Política de Privacidad
            </button>
            <span className="text-sage-dark/30" data-id="element-147">|</span>
            <button onClick={() => setShowTerms(true)} className="text-sage-dark/80 hover:text-amber transition-colors underline underline-offset-4" data-id="element-148">
              Términos y Condiciones
            </button>
          </div>
          <p className="mb-4" data-id="element-149">
            © {new Date().getFullYear()} Protocolo Nutri-Sync. Todos los
            derechos reservados.
          </p>
          <p className="text-sage-dark/60 max-w-2xl mx-auto text-xs leading-relaxed" data-id="element-150">
            Descargo de responsabilidad: La información proporcionada en este
            sitio web y en el Protocolo Nutri-Sync tiene fines puramente
            educativos e informativos. No pretende sustituir el consejo,
            diagnóstico o tratamiento médico profesional. Siempre busque el
            consejo de su médico u otro proveedor de salud calificado con
            cualquier pregunta que pueda tener sobre una condición médica.
          </p>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-151">
        <p data-id="element-152">
          <strong data-id="element-153">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-154">
          En Protocolo Nutri-Sync, respetamos y protegemos la privacidad de
          nuestros usuarios. Esta política describe cómo recopilamos, usamos y
          protegemos su información personal.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-155">
          1. Información que Recopilamos
        </h4>
        <p data-id="element-156">
          Recopilamos únicamente la información necesaria para procesar su
          compra y entregar el producto digital, incluyendo: nombre, dirección
          de correo electrónico e información de pago.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-157">
          2. Uso de la Información
        </h4>
        <p data-id="element-158">
          Su información se utiliza exclusivamente para: procesar transacciones,
          enviar el producto adquirido y comunicar actualizaciones relevantes
          sobre su compra.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-159">
          3. Protección de Datos
        </h4>
        <p data-id="element-160">
          Implementamos medidas de seguridad estándar de la industria para
          proteger su información personal. No vendemos, intercambiamos ni
          transferimos su información personal a terceros.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-161">4. Cookies</h4>
        <p data-id="element-162">
          Nuestro sitio puede utilizar cookies para mejorar la experiencia del
          usuario. Puede configurar su navegador para rechazar cookies, aunque
          esto puede afectar la funcionalidad del sitio.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-163">
          5. Sus Derechos
        </h4>
        <p data-id="element-164">
          Usted tiene derecho a acceder, rectificar o eliminar sus datos
          personales en cualquier momento.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-165">
        <p data-id="element-166">
          <strong data-id="element-167">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-168">
          Al acceder y utilizar este sitio web y adquirir el Protocolo
          Nutri-Sync, usted acepta los siguientes términos y condiciones.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-169">
          1. Producto Digital
        </h4>
        <p data-id="element-170">
          El Protocolo Nutri-Sync es un producto digital de información
          educativa. Una vez completada la compra, recibirá acceso inmediato al
          contenido descargable.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-171">
          2. Uso del Contenido
        </h4>
        <p data-id="element-172">
          El contenido es para uso personal y no comercial. Queda prohibida la
          reproducción, distribución o reventa del material sin autorización
          expresa.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-173">
          3. Descargo Médico
        </h4>
        <p data-id="element-174">
          Este producto tiene fines educativos e informativos únicamente. No
          constituye consejo médico, diagnóstico ni tratamiento. Consulte
          siempre a un profesional de la salud antes de realizar cambios en su
          dieta o suplementación.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-175">4. Resultados</h4>
        <p data-id="element-176">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que dependen de múltiples factores
          individuales.
        </p>
        <h4 className="font-bold text-forest text-base mt-4" data-id="element-177">
          5. Política de Reembolso
        </h4>
        <p data-id="element-178">
          Debido a la naturaleza digital del producto, todas las ventas son
          finales. Si experimenta problemas técnicos con la descarga, haremos
          todo lo posible por resolverlos.
        </p>
      </Modal>
    </>;
}